import { Checkbox, CheckboxGroup, Flex, styled } from '@creditas-ui/react';
import React from 'react';
import { useCallback } from 'react';
import { useEjnFilters } from '../../../contexts/ejn';
import { extrajudicialNotificationStatus } from '../../../types';

const FeatureFilterContainer = styled.div`
  margin-top: 16px;

  > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

const EjnFilterByStatusComponent: React.FC = () => {
  const { changeFilter, statuses } = useEjnFilters();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const handleChangeValue = useCallback((selectedValues: string[]) => {
    changeFilter({
      statuses: selectedValues,
    });
  }, []);

  return (
    <FeatureFilterContainer>
      <CheckboxGroup
        component={Flex}
        spaceY="2rem"
        onChange={handleChangeValue}
        values={statuses}
      >
        {extrajudicialNotificationStatus.map((status) => (
          <Checkbox key={status} id={status} value={status} label={status} />
        ))}
      </CheckboxGroup>
    </FeatureFilterContainer>
  );
};

const EjnFilterByStatus = React.memo(EjnFilterByStatusComponent);

export default EjnFilterByStatus;
